import type { Action } from 'redux';
import dash_api from '../../../../main/support/dash_api';
import type { AdPartner } from '../../../../main/types/adPartnerTypes';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';
import type {
  CreateInternalAdPartnerRequestActionPayload,
  CreateInternalAdPartnerResponseActionPayload,
} from '../AdPartner.types';

const CreateInternalAdPartner = new ReduxAsyncAction<
  'AD_PARTNER_CREATE_INTERNAL',
  CreateInternalAdPartnerRequestActionPayload,
  CreateInternalAdPartnerResponseActionPayload
>('AD_PARTNER_CREATE_INTERNAL');

CreateInternalAdPartner.registerRequest(async ({ internalPartner, product }) => {
  const { data } = await dash_api.post<AdPartner>('/v1/ad-networks/internal-partner', {
    internalPartner,
    product,
  });

  return {
    selectedPartner: data,
  };
});

export const CREATE_INTERNAL_AD_PARTNER = CreateInternalAdPartner.actionNamespaceConstants;

export const createInternalAdPartner = CreateInternalAdPartner.request;

export type CreateInternalAdPartnerResponseAction = Action<typeof CREATE_INTERNAL_AD_PARTNER.response> & {
  data: CreateInternalAdPartnerResponseActionPayload;
};
